import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import axios from 'axios';
Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$SysName = "管理系统"
Vue.prototype.$axios = axios;

Vue.prototype.$appids ='411515a4704b000756977f3c4bc0a7ef'   //验证唯一标识
Vue.prototype.$PubUrl = 'http://47.97.3.24:1060/'
// Vue.prototype.$upFileAddr='http://192.168.31.240:8083/api/UserInfoAPI/UpDataFile'
Vue.prototype.$upFileAddr='http://47.97.3.24:8083/api/UserInfoAPI/UpDataFile'
//登录控制  状态管理若存在已登录信息，则首页  否之，登录页
router.beforeEach((to ,from ,next)=>{
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // if(store.state.LoginInfo.isLogin==0 && to.path !='/login'){
  //   next({
  //     path:'/login'
  //   })
  // }else{
  //   next()
  // }
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
            var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            var ret = GetRet();
            function GetRet(){
              if(isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if(fIEVersion == 7) {
                    return 7;
                } else if(fIEVersion == 8) {
                    return 8;
                } else if(fIEVersion == 9) {
                    return 9;
                } else if(fIEVersion == 10) {
                    return 10;
                } else {
                    return 6;//IE版本<=7
                }   
            } else if(isEdge) {
                return 'edge';//edge
            } else if(isIE11) {
                return 11; //IE11  
            }else{
                return -1;//不是ie浏览器
            }
            }
          if(ret !=-1){
            alert('仅支持ie版本11以上，请升级版本或更换浏览器访问，谢谢');
            window.close();
          }else{
            next()
          }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
